<div class="category-list-container">
  <div class="content">
    <kion-headline-tag [title]="component.title" [titleSize]="component.titleSize"></kion-headline-tag>
    <div class="category">
      <kion-cms-category-list-item
        *ngFor="let category of lazyCategories$ | async"
        [category]="category"
      ></kion-cms-category-list-item>
    </div>
  </div>
</div>
